import moment from "moment";
import PropTypes from "prop-types";
import React from "react";
import { useParams } from "react-router-dom";

import ToBack from "../components/ToBack";
import reducer from "../reducer";

// import { useSelector } from 'react-redux';

const LetfMessage = ({ name, dtime, content }) => (
  <div className="row p-2">
    <div className="col">
      {/* <div className="pull-left pr-2" >
        <img className="rounded-circle message-img" src="lib/img/u868.png" alt="" />
      </div> */}
      <div className="pull-left message-text shadow border rounded p-2">
        {name} {moment(dtime).format("YYYY-MM-DD HH:mm")}
        <br />
        &nbsp;&nbsp;&nbsp;
        {content}
      </div>
    </div>
  </div>
);

const RightMessage = ({ name, dtime, content }) => (
  <div className="row p-2">
    <div className="col">
      {/* <div className="pull-right pl-2" >
        <img className="rounded-circle message-img" src="lib/img/u868.png" alt="" />
      </div> */}
      <div className="pull-right message-text shadow border rounded p-2">
        {name} {moment(dtime).format("YYYY-MM-DD HH:mm")}
        <br />
        &nbsp;&nbsp;&nbsp;
        {content}
      </div>
    </div>
  </div>
);

const messagePropType = {
  name: PropTypes.string.isRequired,
  dtime: PropTypes.string.isRequired,
  content: PropTypes.string.isRequired,
};

LetfMessage.propTypes = messagePropType;
RightMessage.propTypes = messagePropType;

// const Mianshi = props => (
//   <>
//     <div className="row p-2 ">
//       <div className="col">
//         面试邀请
//       </div>
//     </div>
//     <hr className="m-1" />
//     <div className="row p-2  mt-2" style={{ fontSize: 14 }}>
//       <div className="col" >
//         {props.remark}
//       </div>
//     </div>
//     <div className="row p-2">
//       <div className="col">
//         <span className="text-muted" style={{ fontSize: 10 }}>
//           面试地点: {props.address}<br />
//           面试时间: {props.datime}<br />
//           面试岗位: {props.recruitment_name}<br />
//           联系电话: {props.phone}<br />
//         </span>
//       </div>
//     </div>
//   </>
// )

export default function Chat() {
  // eslint-disable-next-line
  const [state, dispatch] = React.useReducer(reducer, {
    PROGRESS: 0,
    conversation: [],
  });
  const auth = JSON.parse(localStorage.getItem("auth"));
  // const auth = useSelector((state) => state.auth);
  const { user_id, title } = useParams();
  // eslint-disable-next-line
  const [text, setText] = React.useState("");
  const handleChange = (event) => {
    setText(event.target.value.trim());
  };
  const handlePush = () => {
    if (text === "") {
      return;
    }
    fetch("/api/miscellaneous/message", {
      method: "POST",
      headers: { "content-type": "application/json" },
      body: JSON.stringify({
        ref_id: auth.id,
        ref_id2: user_id,
        dtime: moment().format("YYYY-MM-DD HH:mm"),
        category: "咨询企业",
        tag: "个人用户",
        content: text,
      }),
    }).then((response) => {
      if (response.status === 200) {
        window.location.reload(true);
      } else alert("发送失败");
    });
  };

  React.useEffect(() => {
    if (auth !== null) {
      fetch(`/api/resume/user/${auth.id}?u_id=${auth.uuid}`)
        .then((res) => res.json())
        .then((res) => {
          if (res === null) {
            alert("请先填写简历");
            location.href = "#/我的/简历";
          }
        });
    }
  }, []);

  React.useEffect(() => {
    if (auth !== null) {
      if (state.PROGRESS === 0) {
        const url = [
          "/api/miscellaneous/message",
          "?option=by-ref_id-ref_id2-category",
          `&ref_id=${auth.id}`,
          `&ref_id2=${user_id}`,
          "&category=咨询企业",
        ];
        fetch(url.join(""))
          .then((response) => response.json())
          .then((data) => {
            dispatch({
              type: "set",
              payload: { key: "conversation", value: data },
            });
            dispatch({
              type: "set",
              payload: { key: "PROGRESS", value: state.PROGRESS + 1 },
            });
          });
      } else if (state.PROGRESS === 1) {
        if (state.conversation.length === 0) return;
        const timer = setTimeout(() => {
          const lt = state.conversation
            .filter((element) => element.tag === "企业用户")
            .map((current) => current.id);
          const url = [`/api/miscellaneous/message/${auth.id}`, "?option=status-by-id_list"];
          fetch(url.join(""), {
            method: "PUT",
            headers: { "content-type": "application/json" },
            body: JSON.stringify({
              id_list: lt.join(","),
              status: "已读",
            }),
          });
          dispatch({
            type: "set",
            payload: { key: "PROGRESS", value: 0 },
          });
        }, 2000);
        return () => clearTimeout(timer);
      }
    }
  }, [state.PROGRESS]);

  React.useEffect(() => {
    document.documentElement.scrollTop = document.body.scrollHeight;
  }, [state.conversation]);

  const handleLogIn = async () => {
    location.href = "#/登录";
  };

  return (
    <>
      {auth === null ? (
        <div className="container-fluid">
          <ToBack href="#我的" category="我的简历" />
          <div className="chat-login">
            <h6>登录后可以查看消息</h6>
            <button
              type="button"
              style={{ width: "25%" }}
              className="btn btn-block mx-auto rounded-pill button-background text-white font-weight"
              onClick={handleLogIn}
            >
              登&nbsp;录
            </button>
          </div>
        </div>
      ) : (
        <div>
          <div className="fixed-top border-bottom" style={{ fontSize: 14 }}>
            <div className="p-1 bg-white">
              <ToBack category={title} />
            </div>
          </div>
          <div className="container-fluid chat-background" id="chat-body" style={{ fontSize: 14 }}>
            <div className="row p-4" />
            <div className="row " id="chat-body3">
              <div className="col" id="chat-body1">
                {0 < state.conversation.length &&
                  state.conversation.map((item, inx) => {
                    return auth.id === item.ref_id ? (
                      <RightMessage key={item.dtime + inx.toString()} name="我:" {...item} />
                    ) : (
                      <LetfMessage key={item.dtime + inx.toString()} name={title} {...item} />
                    );
                  })}
              </div>
            </div>
          </div>
          <div style={{ height: 50 }} />
          <ul className="nav bg-light nav-light fixed-bottom nav-bottom border-top">
            <div className="input-group ">
              <input
                type="text"
                value={text}
                onChange={handleChange}
                className="form-control rounded-0 h-100 input-f"
                style={{ outline: "none" }}
                placeholder="请输入内容"
              />
              <div className="input-group-append">
                {text === "" ? (
                  <button type="button" className="btn btn-secondary rounded-0">
                    发送
                  </button>
                ) : (
                  <button type="button" onClick={handlePush} className="btn btn-primary rounded-0">
                    发送
                  </button>
                )}
              </div>
            </div>
          </ul>
        </div>
      )}
    </>
  );
}
